/* eslint-disable consistent-return */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CardElement, ElementsConsumer } from '@stripe/react-stripe-js';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import DialogActions from '@material-ui/core/DialogActions';
import LinearProgress from '@material-ui/core/LinearProgress';
import * as actions from '../../actions/settings';

const CARD_OPTIONS = {
	// iconStyle: 'solid',
	style: {
		base: {
			iconColor: '#333',
			color: '#333',
			fontWeight: 500,
			fontSize: '16px',
			':-webkit-autofill': { color: '#333' },
			'::placeholder': { color: '#333' }
		},
		invalid: {
			iconColor: 'red',
			color: 'red'
		}
	}
};

const styles = {
	stripeBox: {
		backgroundColor: '#f9f9f9',
		border: '1px #c4c4c4 solid',

		padding: '18px 10px',
		width: '94.5%',
		borderRadius: '5px'
	}
};

class UpdatePaymentForm extends Component {
	state = { loading: false, onHover: false, errorMessage: '' };

	generateStripeToken = async (event) => {
		// Block native form submission.
		if (event && event.preventDefault) {
			event.preventDefault();
		}

		const { stripe, elements } = this.props;

		if (!stripe || !elements) {
			// Stripe.js has not loaded yet. Make sure to disable
			// form submission until Stripe.js has loaded.
			return;
		}

		// Get a reference to a mounted CardElement. Elements knows how
		// to find your CardElement because there can only ever be one of
		// each type of element.
		const cardElement = elements.getElement(CardElement);

		const { error, token } = await stripe.createToken(cardElement);

		if (error) {
			return { error: error.message, token: null };
		}
		return { error: false, token };
	};

	handleSubmit = async (e) => {
		if (e.preventDefault) {
			e.preventDefault();
		}

		this.setState({ loading: true });

		const stripe = await this.generateStripeToken();

		if (stripe.error) {
			return this.setState({
				errorMessage: stripe.error,
				loading: false
			});
		}

		const response = await this.props.updatePaymentMethod(stripe.token.id);

		if (response.error) {
			return this.setState({
				errorMessage: response.message,
				loading: false
			});
		}

		this.props.closeDialog(false);

		return this.setState({
			errorMessage: '',
			loading: false
		});
	};

	mouseInStripe = () => {
		this.setState({ onHover: true });
	};

	mouseOutStripe = () => {
		this.setState({ onHover: false });
	};

	render() {
		return (
			<div>
				<div
					style={
						this.state.onHover
							? { ...styles.stripeBox, border: '1px solid #333' }
							: styles.stripeBox
					}
					onMouseEnter={this.mouseInStripe}
					onMouseLeave={this.mouseOutStripe}
				>
					<CardElement
						options={{
							...CARD_OPTIONS,
							disabled: this.state.loading
						}}
					/>
				</div>

				{this.state.loading && (
					<div
						style={{
							marginTop: 2,
							paddingLeft: 2,
							paddingRight: 10
						}}
					>
						<LinearProgress />
					</div>
				)}

				<Typography style={{ fontSize: '0.8rem', color: '#eb3c81' }}>
					{this.state.errorMessage}
				</Typography>
				<DialogActions style={{ paddingTop: 20 }}>
					<Button
						color="primary"
						variant="text"
						onClick={() => this.props.closeDialog(false)}
					>
						Cancel
					</Button>
					<Button
						color="primary"
						variant="contained"
						type="submit"
						disabled={!this.props.stripe || this.state.loading}
						aria-label="Update credit card"
						title="Update credit card"
						onClick={this.handleSubmit}
					>
						Update
					</Button>
				</DialogActions>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		auth: state.auth
	};
}

const InjectedPaymentForm = ({ closeDialog, updatePaymentMethod }) => (
	<ElementsConsumer>
		{({ elements, stripe }) => (
			<UpdatePaymentForm
				elements={elements}
				stripe={stripe}
				closeDialog={closeDialog}
				updatePaymentMethod={updatePaymentMethod}
			/>
		)}
	</ElementsConsumer>
);

export default connect(mapStateToProps, actions)(InjectedPaymentForm);



// WEBPACK FOOTER //
// ./src/components/settings/UpdatePaymentForm.js